import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  selectCPMFTrackingForecastModelId,
  selectCPMFTrackingForecastMultiModelIds,
  setModelId,
  setMultiModelIds,
} from 'redux/reducers/meteorologyFieldsTrackingForecastControlPanelReducer';
import useModelOptions from './useModelOptions';

export default function useModels() {
  const { models } = useModelOptions();

  const selectedModelId: number | undefined = useSelector(selectCPMFTrackingForecastModelId);
  const selectedMultiModelIds: number[] = useSelector(selectCPMFTrackingForecastMultiModelIds);

  const selectedModel = useMemo(() => {
    if (!selectedModelId || !models.length) return undefined;
    return models.find((model) => model.id === selectedModelId);
  }, [selectedModelId, models]);

  const setModel = (value: string) => {
    const model = models.find((m) => m.value === value);
    if (model) store.dispatch(setModelId(model.id));
  };

  const toggleMultiModel = (value: string) => {
    const model = models.find((m) => m.value === value);
    if (model) {
      if (selectedMultiModelIds.includes(model.id)) {
        const newModelIds = selectedMultiModelIds.filter((id) => id !== model.id);
        store.dispatch(setMultiModelIds(newModelIds));
      } else {
        const newModelIds = [...selectedMultiModelIds, model.id];
        store.dispatch(setMultiModelIds(newModelIds));
      }
    }
  };

  const isModelSelected = (value: string) => {
    const model = models.find((m) => m.value === value);
    return model ? selectedMultiModelIds.includes(model.id) : false;
  };

  return {
    models, selectedModel, setModel, toggleMultiModel, isModelSelected,
  };
}
